module.exports = __webpack_public_path__ + "static/img/coupon2.ed277cc0.png";